import Loader from '@/commons/loader';
import { useFetch } from '@/modules/orders/hooks/useFetch';
import { changeMethodsFactureService, getFactureIdService } from '@/services';
import { errorFacture } from '@/utils/errors';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import PopCashRegister from '../change-pay-method';

interface SimpleDialogProps {
  open: boolean;
  value: string;
  onClose: (value: string) => void;
}

export function DialogChangePayMethod(props: SimpleDialogProps) {
  const { onClose, value, open } = props;
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = () => {
    onClose(value);
  };
  const { fetchProperties } = useFetch({ fetchFunction: changeMethodsFactureService });

  const handleChangeMethodsFacture = async (values: any) => {
    try {
      await fetchProperties(value, values);
      enqueueSnackbar('Se cambio metodo de pago con exito!');
      handleClose();
    } catch (error) {
      const newMessage = errorFacture[error.message ?? ''];
      if (newMessage) {
        enqueueSnackbar(newMessage, { variant: 'error' });
      } else {
        enqueueSnackbar('Problemas cambiando metodo de pago', { variant: 'error' });
      }
    }
    
  };

  const { isLoading, data, fetchId, setData } = useFetch({ fetchFunction: getFactureIdService });
  const handleGetFactures = async () => {
    try {
      const resolve = await fetchId(value);
      setData({
        ...resolve,
        paymentMethod: {
          cash: resolve?.cash ?? 0,
          creditCard: resolve?.creditCard ?? 0,
          transference: resolve?.transference ?? 0,
        },
      });
    } catch (error) {
      console.log('🚀 ~ file: index.tsx:56 ~ handleGetFactures ~ error:', error);
    }
  };

  useEffect(() => {
    handleGetFactures();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return <PopCashRegister current={data?.paymentMethod ?? {}} onSave={handleChangeMethodsFacture} />;
}
